import Types from 'Types';

export const getOptions = (state: Types.RootState) =>
  state.productOptions.options;

export const getPredefinedCoverImages = (state: Types.RootState) =>
  state.productOptions.predefinedCoverImages;
